import { checkIfOpen } from './checkIfOpen';
import { getNextTimeEvent } from './getNextTimeEvent';

/**
 * Builds an array of LocationTile objects from a locationsResponse array.
 *
 * @param {LocationTile[]} locationsResponse - The array of location objects to transform.
 * @param {string} locationDetailPagePart - The URL part for location detail pages.
 * @returns {LocationTileData[]} Array of LocationTile objects.
 */
export const buildLocationTiles = (
	locationsResponse,
	locationDetailPagePart
) => {
	if (!Array.isArray(locationsResponse)) return [];
	return locationsResponse.map((location) => {
		const nameComaIndex = location.name.indexOf(',');
		const name =
			nameComaIndex !== -1
				? location.name.slice(0, nameComaIndex)
				: location.name;
		const now = new Date();
		const currentDay = now
			.toLocaleString('en-us', {
				weekday: 'long',
				timeZone: location.timeZoneId
			})
			.toLowerCase();
		const currentTime = now.toLocaleTimeString('en-us', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: true,
			timeZone: location.timeZoneId
		});
		// Check if the location is open now
		const isOpen = checkIfOpen(
			location.hours,
			currentDay,
			currentTime.replace(/\s/g, '')
		);
		const openCloseText = getNextTimeEvent(
			location.hours,
			currentDay,
			currentTime.replace(/\s/g, '')
		);
		const href = `${locationDetailPagePart}/${encodeURIComponent(
			name.replace(/\s+/g, '-')
		)}/${encodeURIComponent(location.city.replace(/\s+/g, '-'))}.htm`;
		return {
			location: {
				...location,
				address1: '',
				name,
				distance: location.distance.toFixed(0), // truncate distance to 0 decimal places
				isOpen,
				openCloseText,
				dealershipImgUrl:
					'https://static.dealer.com/assets/images/tiles/example-location.jpg',
				href
			},
			displayType: 'media'
		};
	});
};
